/*
 */

// Production API URl
export const API = `https://admin.indiangallbladdernetwork.com/`;
export const API_JAVA = `https://report.indiangallbladdernetwork.com/api/`;

// Staging API URL
// export const API = `http://209.182.232.92:9055/`;

// Local APi
// export const API = `http://192.168.1.4:8055/`;
// export const API_JAVA = `http://192.168.1.30:9011/api/`;

export const PUBLIC_URL = `https://admin.indiangallbladdernetwork.com/`;
